import { Component } from "react";
import { connect } from "react-redux";
import {
	getImputationInProgressByDay,
	gotActivityInProgress,
	getAllImputations,
} from "../redux/imputations/imputationsActions";
import { stopImputationInDb, addImputationInDb } from "../redux/imputations/imputationsEditionActions";
import { cloneImputation } from "../redux/imputations/imputationsCast";
import { createOrGetDayByDate, refreshAllDaysList } from "../redux/day/dayActions";
import { setActiveDay } from "../redux/day/dayEditionActions";
import { plusOneDay, minusOneDay, getEndOfDay } from "../time";
import ModifyImputation from "./ModifyImputation";
import DrawDay from "./DrawDay";
import DrawListDay from "./DrawListDay";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import "./Scheduler.css";
import moment from "moment";
import "moment/locale/fr";
import { throwErrorMessage } from "../lib/error_helper";
import { getStartedWorkOrder } from "../redux/intervention/interventionActions";
import InterventionAlreadyInProgressModal from "./Interventions/InterventionAlreadyInProgressModal";
import DatePicker from "./Input/DatePicker";
import { PickersDay } from "@mui/x-date-pickers";

class Scheduler extends Component {
	constructor(props) {
		super(props);
		this.mounted = true;

		this.state = {
			imputation: null,
			change_imputation: false,
			current_day: props.current_day,
			previous_day: null,
			next_day: null,
			display_list: true,
			modifiable: props.modifiable,
			pauseInterventionModalOpenned: false,
			interventionToPause: null,
			forcingEndIntervention: false,
			displayDay: this.displayDay.bind(this),
		};
		this.loadAllImputations();
	}

	componentWillUnmount() {
		this.mounted = false;
	}

	componentDidMount() {
		this.displayDay(this.props.current_day);
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		let modifiedState = prevState;

		let currentDayChange = JSON.stringify(nextProps.current_day) !== JSON.stringify(prevState.current_day);
		if (nextProps.current_day !== undefined && currentDayChange) {
			modifiedState.displayDay(nextProps.current_day);
		}

		if (nextProps.displayModeListe !== undefined) modifiedState.display_list = nextProps.displayModeListe;

		return modifiedState;
	}

	loadAllImputations() {
		this.props.getAllImputations(this.state.current_day);
	}

	//fonction principale du planning pour l'affichage des items
	async displayDay(day) {
		if (this.mounted)
			await this.setState({
				current_day: day,
				previous_day: null,
				next_day: null,
			});

		this.props.refreshAllDaysList();

		let previous = await createOrGetDayByDate(day.user_id, minusOneDay(day.date));
		let next = await createOrGetDayByDate(day.user_id, plusOneDay(day.date));
		this.previousDay(previous.day, previous.day_string, 1);
		this.nextDay(next.day, next.day_string, 1);
	}

	//vérification des jours précédents
	async previousDay(day, day_string, nb) {
		if (nb !== 30) {
			if (day !== null) {
				if (!this.mounted) return;

				this.setState({ previous_day: day });
				let imputation = await getImputationInProgressByDay(day.id);

				if (!this.mounted) return;

				await this.endPreviousDay(imputation);
			} else {
				let previous = await createOrGetDayByDate(this.state.current_day.user_id, minusOneDay(day_string));

				if (!this.mounted) return;

				await this.previousDay(previous.day, previous.day_string, nb + 1);
			}
		}
	}

	//action au chevauchement de jour d'une imputation
	async endPreviousDay(imputations) {
		if (imputations.length > 0) {
			let last_imputation = imputations[0];
			this.props.stopImputationInDb(
				last_imputation.id,
				new Date(getEndOfDay(this.state.previous_day.date).setSeconds(59))
			);
			this.props.addImputation(cloneImputation(last_imputation, this.state.current_day));
			//FIXME: Why? Ça sert à rien...
			await gotActivityInProgress(last_imputation);
		}
	}

	//vérification des jours suivants
	async nextDay(day, day_string, nb) {
		if (nb !== 30) {
			if (day !== null) {
				if (this.mounted) await this.setState({ next_day: day });
			} else {
				let next = await createOrGetDayByDate(this.state.current_day.user_id, plusOneDay(day_string));
				await this.nextDay(next.day, next.day_string, nb + 1);
			}
		}
	}

	//action du bouton de jour suivant
	dayPlus() {
		this.loadAllImputations();
		this.props.changeDay(this.state.next_day);
	}

	//action du bouton de jour précédent
	dayMinus() {
		this.loadAllImputations();
		this.props.changeDay(this.state.previous_day);
	}

	closePauseInterventionModal() {
		this.setState({
			pauseInterventionModalOpenned: false,
			forcingEndIntervention: false,
			updatingImputation: null,
		});
	}

	//action de clic sur un item
	launchModification(imputation) {
		if (this.mounted) {
			getStartedWorkOrder().then((intervention) => {
				if (intervention && !this.state.forcingEndIntervention) {
					this.setState({
						interventionToPause: intervention,
						pauseInterventionModalOpenned: true,
						updatingImputation: imputation,
					});

					return;
				}

				this.setState({
					imputation: Object.assign({}, imputation),
					change_imputation: true,
					pauseInterventionModalOpenned: false,
					forcingEndIntervention: false,
					updatingImputation: null,
				});
			});
		}
	}

	//retour de la page de modification
	modificationImputation() {
		if (this.mounted)
			this.setState({
				imputation: null,
				change_imputation: false,
			});
	}

	onDateChange(date) {
		this.loadAllImputations();
		this.props.allDays.forEach((day) => {
			let currentDate = moment(day.date);
			if (currentDate.isSame(date, "day")) {
				this.props.setActiveDay(day);
				return;
			}
		});
	}

	renderDay(date, selectedDates, pickersDayProps) {
		let associatedDay = null;
        let selectedDate = selectedDates[0];

		this.props.allDays.forEach((day) => {
			let currentDate = moment(day.date);
			if (currentDate.isSame(date, "day")) associatedDay = day;
		});

		let today = date.isSame(moment(), "day");
		let currentDate = selectedDate.isSame(date, "day");
		let currentDateHaveImputations;

		if (associatedDay)
			currentDateHaveImputations = this.props.allImputations.filter(
				(imputation) => imputation.day_id === associatedDay.id
			);

		let classes = "calendar-day ";

		if (today) classes = classes.concat("calendar-day-today ");

		if (currentDate) classes = classes.concat("calendar-day-highlight ");

		if (associatedDay && associatedDay.validation) classes = classes.concat("calendar-day-validated ");
		else if (currentDateHaveImputations && currentDateHaveImputations.length > 0)
			classes = classes.concat("calendar-day-validation-required ");

        return (
            <PickersDay
              {...pickersDayProps}
              disabled={!associatedDay}
              className={classes}
              key={date}
            />
          );
	}

	forceEndIntervention() {
		this.setState({
			forcingEndIntervention: true,
		});

		this.launchModification(this.state.updatingImputation);
	}

	render() {
		let datePickerValue = moment(this.state.current_day.date);

		return (
			<Card
				id="Planning"
				className="card col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding container-with-footer"
			>
				<CardContent className="without-side-padding">
					<div id="date_name" style={{ height: "auto", position: "relative" }} className="row">
						{this.state.previous_day !== null ? (
							<div className="col-lg-2 col-md-2 col-sm-2 col-2" style={{ display: "inline-flex" }}>
								<Button
									onClick={this.dayMinus.bind(this)}
									style={{ margin: "auto", color: "#005bba" }}
								>
									<i className="material-icons">chevron_left</i>
								</Button>
							</div>
						) : (
							<div className="col-lg-2 col-md-2 col-sm-2 col-2" style={{ display: "inline-flex" }} />
						)}
						<div className="col-lg-8 col-md-8 col-sm-8 col-8">
							<div className="span-center">
								<DatePicker
									value={datePickerValue}
									disableFuture
									renderDay={this.renderDay.bind(this)}
									emptyLabel="La date est invalide"
									invalidDateMessage="La date est invalide"
									invalidLabel="La date est invalide"

									style={{ maxWidth: "150px" }}
									inputFormat={"ddd D MMM YYYY"}
									onChange={this.onDateChange.bind(this)}
								/>
							</div>
						</div>
						{this.state.next_day !== null ? (
							<div className="col-lg-2 col-md-2 col-sm-2 col-2" style={{ display: "inline-flex" }}>
								<Button
									onClick={this.dayPlus.bind(this)}
									style={{ margin: "auto", color: "#005bba" }}
								>
									<i className="material-icons">chevron_right</i>
								</Button>
							</div>
						) : (
							<div style={{ display: "inline-flex" }} />
						)}
					</div>
					<DrawListDay
						modification={this.launchModification.bind(this)}
						day={this.state.current_day}
						modifiable={this.props.modifiable}
						style={
							this.state.display_list
								? {
										height: "auto",
										margin: "0px",
										position: "relative",
										width: "100%",
										minHeight: "300px",
								  }
								: { display: "none" }
						}
					/>
					<DrawDay
						modification={this.launchModification.bind(this)}
						day={this.state.current_day}
						modifiable={this.props.modifiable}
						style={
							this.state.display_list
								? { display: "none" }
								: { height: "auto", margin: "0px", position: "relative", width: "100%" }
						}
					/>
					{this.state.change_imputation ? (
						<ModifyImputation
							imputation={this.state.imputation}
							day={this.state.current_day}
							end={this.modificationImputation.bind(this)}
						/>
					) : null}
					<InterventionAlreadyInProgressModal
						interventionInProgress={this.state.interventionToPause}
						imputationMode
						forceEndIntervention={this.forceEndIntervention.bind(this)}
						opened={this.state.pauseInterventionModalOpenned}
						closeModal={this.closePauseInterventionModal.bind(this)}
					/>
				</CardContent>
			</Card>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		activeUser: state.activeUser,
		current_day: state.current_day,
		allDays: state.allDays.allDays,
		allImputations: state.imputations.allImputations,
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		stopImputationInDb: (id, time) => dispatch(stopImputationInDb(id, time)),
		addImputation: (imputation) => dispatch(addImputationInDb(imputation)),
		refreshAllDaysList: () => dispatch(refreshAllDaysList()),
		setActiveDay: (day) => dispatch(setActiveDay(day)),
		getAllImputations: (day) => dispatch(getAllImputations(day)),
		throwErrorMessage: (options) => dispatch(throwErrorMessage(options)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Scheduler);
